import { Input } from "./ui/input";
import { Label } from "./ui/label";

export const Field = ({ label, id, error, hint, className = "", ...props }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label htmlFor={id} className="text-xs font-medium text-slate-600 uppercase tracking-wider">
      {label}
    </Label>
    <Input id={id} data-testid={`${id}-input`} className="h-10 bg-white" {...props} />
    {error ? (
      <p className="text-xs text-rose-600" data-testid={`${id}-error`}>{error}</p>
    ) : hint ? (
      <p className="text-xs text-slate-500">{hint}</p>
    ) : null}
  </div>
);
